/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev2_QuoteInputs */

const en_funnel_sq_rev2_quote = /** @type {(inputs: Funnel_Sq_Rev2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This gave me back reading. Honestly emotional the first time I pressed play.`)
};

const es_funnel_sq_rev2_quote = /** @type {(inputs: Funnel_Sq_Rev2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me devolvió la lectura. La primera vez que le di a reproducir me emocionó de verdad.`)
};

/**
* | output |
* | --- |
* | "This gave me back reading. Honestly emotional the first time I pressed play." |
*
* @param {Funnel_Sq_Rev2_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev2_quote = /** @type {((inputs?: Funnel_Sq_Rev2_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev2_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev2_quote(inputs)
	return en_funnel_sq_rev2_quote(inputs)
});